window.infoLoteMateriaPrimaSoplado = null;

if (window.location.pathname === '/soplado/periodo' || window.location.pathname === '/zona-trabajo') {

    window.infoLoteMateriaPrimaSoplado = (idLineaLotePreformaSoplado) => {
        const url       = `/api/soplado/lineaLoteMateriaPrima?idLine=${idLineaLotePreformaSoplado}`;
        const formEditar = document.querySelector('#formEditarLoteMateriaPrimaSoplado');
        const contEditar = document.querySelector('#contEditarLoteMateriaPrimaSoplado');

        fetch(url, { method: 'GET', credentials: 'include' })
            .then(response => {
                if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
                return response.json();
            })
            .then(result => {
                const data = result.result[0];
                if (!data || !formEditar) return;

                contEditar.querySelectorAll('.inputRojo').forEach(el => el.classList.remove('inputRojo'));

                formEditar.querySelector('#horaInicio').value      = data.horaInicio || '';
                formEditar.querySelector('#horaFin').value         = data.horaFin    || '';
                formEditar.querySelector('#numeroLote').value      = data.numeroLote || '';
                formEditar.querySelector('#observacionesLote').value = data.Observaciones || '';
            })
            .catch(error => {
                console.error('Error al cargar info del lote:', error);
                alert('Error al cargar la información del lote. Por favor, intenta de nuevo.');
                window.location.reload();
            });
    };

    document.addEventListener('click', function (e) {
        const fila = e.target.closest('.trSelectLoteMateriaPrimaSoplado');
        if (!fila) return;

        const idLote     = fila.getAttribute('data-id');
        const idPreforma = fila.getAttribute('data-id-materia-prima'); // idPreforma viene en este data attr
        const material   = fila.getAttribute('data-material');

        const formEditar  = document.querySelector('#formEditarLoteMateriaPrimaSoplado');
        const formReporte = document.querySelector('#formProduccionSoplado');

        if (!formEditar || !formReporte || !idLote || isNaN(idLote)) {
            alert('Error al abrir el modal. Por favor, intenta de nuevo.');
            window.location.reload();
            return;
        }

        const idReporte = formReporte.querySelector('#idReporteSoplado').value;
        if (!idReporte) {
            alert('Error al obtener el reporte. Por favor, intenta de nuevo.');
            window.location.reload();
            return;
        }

        formEditar.querySelector('#idLineaLotePreformaSoplado').value = idLote;
        formEditar.querySelector('#idEncabezadoReporteSoplado').value = idReporte;
        formEditar.querySelector('#idPreforma').value                 = idPreforma || '';
        formEditar.querySelector('#material').value                   = material   || '';

        window.infoLoteMateriaPrimaSoplado(idLote);
    });

    document.addEventListener('submit', async function (e) {
        if (e.target.id !== 'formEditarLoteMateriaPrimaSoplado') return;

        const botonActivo = e.submitter;
        if (!botonActivo || botonActivo.id !== 'btnEditarLoteMateriaPrimaSoplado') return;

        e.preventDefault();

        const formulario  = e.target;
        const modalPadre  = formulario.closest('.modal');
        const spinner     = formulario.querySelector('#spinner');
        const btnEditar   = formulario.querySelector('#btnEditarLoteMateriaPrimaSoplado');
        const formData    = new FormData(formulario, botonActivo);

        if (btnEditar) btnEditar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(el => el.classList.remove('inputRojo'));

        try {
            const respuesta = await fetch('/api/soplado/editar-lote-materia-prima', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            let json;
            try {
                json = await respuesta.json();
            } catch {
                throw new Error('La respuesta del servidor no es JSON válido.');
            }

            if (!respuesta.ok) {
                lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
                return;
            }

            if (!json.result) {
                lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                resultado.errores.forEach(function (error) {
                    lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                    if (error.campo) {
                        const campo = formulario.querySelector('[name="' + error.campo + '"]');
                        if (campo) campo.classList.add('inputRojo');
                    }
                });
                return;
            }

            const idReporte = formulario.querySelector('#idEncabezadoReporteSoplado').value;
            const params    = new URLSearchParams(window.location.search);
            const mes       = params.get('mes');
            const anio      = params.get('año');

            if (modalPadre) modalPadre.classList.remove('modal--show');

            lanzarAlerta(resultado.mensaje || 'Lote editado con éxito.', 'alerta-verde');

            window.actualizarModalReporteSoplado(idReporte);
            window.actualizarTableroSopladoPeriodo(mes, anio);
            window.actualizarTablaSopladoPeriodo(mes, anio);
            if (window.location.pathname === '/zona-trabajo') {
                if (typeof window.actualizarZonaTrabajo === 'function') {
                    if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
                }
            }

        } catch (error) {
            console.error('Error:', error);
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } finally {
            if (btnEditar) btnEditar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}
